import React, { useContext, useEffect, useState } from "react";
import { Handle } from "react-flow-renderer";
import { Button, Form, Modal } from "react-bootstrap";
import { NodesContext } from "../provider/IvrContext";
import { toast } from 'react-toastify';
import { BACKEND_API_BASE_URL} from "../../../../../utilities/constant";
import { getApiCall } from '../../../../../service/httpCall';


const TransferNode = ({ data, id }) => {
    const { updateNodeData, onRemove } = useContext(NodesContext)
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [groupList, setGroupList] = useState([]);

    const transferAction = data.action || {};
    const type = transferAction.type?.replace("transfer_", "") || "";
    const groupId = transferAction.id || "";

    useEffect(() => {
        getApiCall(`${BACKEND_API_BASE_URL}/v2/agent-group/`)
            .then(setGroupList)
            .catch(console.log);
    }, [data.userId]);

    const updateNode = (updates) => {
        updateNodeData(id, updates);
    };

    const handleTypeChange = (e) => {
        const newType = e.target.value;

        updateNode({
            action: newType
                ? { type: `transfer_${newType}` }
                : {},
        });
    };

    const handleGroupChange = (e) => {
        const selectedGroup = groupList.find(
            (g) => g.groupId.toString() === e.target.value
        );

        if (!selectedGroup) return;

        updateNode({
            action: {
                type: "transfer_group",
                id: selectedGroup.groupId,
                name: selectedGroup.groupName,
            },
        });
    };

    const handleSave = () => {
        toast.success("Details updated successfully.")
        setModalIsOpen(false);
    };

    return (
        <div style={{ position: "relative", width: "80px", height: "40px" }}>
            <div
                className="ivr-flow-node"
                style={{
                    position: "absolute",
                    top: 8,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: "1.5px solid orange",
                    borderRadius: "10px 10px 0 10px",
                    background: "#fff",
                    zIndex: 3,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "11px",
                }}
            >
                <Handle type="target" position="top" style={{ background: "orange" }} />
                <Handle type="source" position="bottom" style={{ background: "orange" }} />

                <span className="ivr-flow-node-label" style={{ fontSize: "10px", fontWeight: "bold", textTransform: "capitalize" }}>
                    {data.label}
                </span>

                <div style={{ display: "flex", gap: "10px" }}>
                    <i
                        className="fa fa-cog ivr-flow-node-icon"
                        style={{ cursor: "pointer", color: "orange" }}
                        onClick={() => setModalIsOpen(true)}
                    />
                    <i
                        className="fa fa-trash ivr-flow-node-icon"
                        style={{ cursor: "pointer", color: "orange" }}
                        onClick={() => onRemove(id)}
                    />
                </div>
            </div>

            <Modal show={modalIsOpen} onHide={() => setModalIsOpen(false)} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Transfer</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Select type</Form.Label>
                            <Form.Control as="select" value={type} onChange={handleTypeChange}>
                                <option value="">Select</option>
                                <option value="group">Group</option>
                            </Form.Control>
                        </Form.Group>

                        {type === "group" && (
                            <Form.Group className="mt-2">
                                <Form.Label>Select Group</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={groupId}
                                    onChange={handleGroupChange}
                                >
                                    <option value="">Select Group</option>
                                    {groupList.map((g) => (
                                        <option key={g.groupId} value={g.groupId}>
                                            {g.groupName}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        )}
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={handleSave}>Save</Button>
                    <Button variant="secondary" onClick={() => setModalIsOpen(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default TransferNode;
